import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from './config';

const ERROR_KEY_PREFIX = 'ErrorCodes-';

export function getErrorMessageFromRestCall(error: any): string {
  console.log(error);
  return 'ErrorCodes-GENERIC_TITLE';
}

export function getErrors(error: any): string[] {
  /**
   * Given an input error object, parse it and return the translation keys
   * for the errors.
   */
  const errorKeys: string[] = [];

  console.log(error);

  try {
    if (error.status === 403) {
      errorKeys.push('ErrorCodes-GENERIC_FORBIDDEN');
    }

    error.error.errors.forEach((item) => {
      if (item.defaultMessage) {
        errorKeys.push(item.defaultMessage);
      } else if (item.errorCode) {
        errorKeys.push(`${ERROR_KEY_PREFIX}${item.errorCode}`);
      }
    });
  } catch (e) {
    // do nothing
  }

  if (errorKeys.length === 0) {
    errorKeys.push('ErrorCodes-GENERIC_UNKNOWN');
  }

  return errorKeys;
}

export function getSingleError(error: any): string {
  return getErrors(error)[0];
}

export function handleErrors(
  error: any,
  ts: TranslateService,
  toastr: ToastrService,
  title = 'ErrorCodes-GENERIC_TITLE'
): void {
  const errors = getErrors(error);

  errors.forEach((key: string) => {
    toastr.error(
      ts.instant(key),
      ts.instant(title),
      {
        ...AppSettings.NOTIFICATIONS_DEFAULT_OPTIONS,
        timeOut: 5000,
        closeButton: true,
        progressBar: true,
      }
    );
  });
}